"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/**
 * Page layout modes
 */
var grid = 'grid';
var _float = 'float';
var _default = exports["default"] = {
  grid: grid,
  "float": _float
};